import { Megaphone } from 'lucide-react';
import type { BroadcastResult } from '../../../lib/adminApi';
import { cn } from '../../../lib/cn';
import { Pill } from '../parts';

function Stat({ label, value, accent }: { label: string; value: number; accent?: boolean }) {
  return (
    <div className="rounded-xl bg-card px-3 py-2">
      <div className="text-[11px] text-ink3">{label}</div>
      <div className={cn('num text-[18px] font-extrabold', accent && 'text-accent-ink')}>{value}</div>
    </div>
  );
}

export function ResultCard({ result }: { result: BroadcastResult }) {
  return (
    <div className="rounded-2xl border border-black/5 bg-wash p-4">
      <div className="flex items-center gap-2">
        <Megaphone size={16} className="text-accent-ink" />
        <span className="text-[13px] font-bold text-ink">
          {result.dryRun ? 'Preview' : result.duplicate ? 'Already sent' : 'Sent'} · {result.audienceLabel}
        </span>
        {result.dryRun ? (
          <Pill>Dry run</Pill>
        ) : result.duplicate ? (
          <Pill tone="gold">No re-send</Pill>
        ) : (
          <Pill tone="accent">Delivered</Pill>
        )}
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 text-[13px]">
        <Stat label="In audience" value={result.audienceSize} />
        <Stat label="Recipients" value={result.recipients} accent />
        <Stat label="Opted out" value={result.optedOut} />
        <Stat label="With devices" value={result.withDevices} />
        {result.dryRun ? (
          <Stat label="Devices reachable" value={result.deviceCount} />
        ) : (
          <>
            <Stat label="Feed items written" value={result.feedWritten} />
            <Stat label="Pushes delivered" value={result.pushDelivered} accent />
          </>
        )}
      </div>
      {result.dryRun && (
        <p className="mt-3 text-[12px] text-ink2">Nothing was sent — review the numbers, then hit Send.</p>
      )}
      {result.duplicate && (
        <p className="mt-3 text-[12px] font-semibold text-gold-ink">
          This exact message was already sent — nothing was delivered again. Edit it to send a new one.
        </p>
      )}
    </div>
  );
}
